import { ReportEntity } from "../domain/report.entity";
import { ReportType } from "../index";
import { reportMessages } from "../messages";

export interface ReportDTO {
  result: ReportResultDTO[];
  page: number;
  totalPages: number;
  totalResults: number;
  size: number;
  reportSummary: ReportSummaryDTO;
}

export interface ReportResultDTO {
  period: string;
  hotelTicker: string;
  group: string;
  partner: string;
  avgStay: number;
  avgAdvance: number;
  bookings: number;
  totalAmount: number;
  avgAmount: number;
  totalRoomsPerNight: number;
  avgAmountRoomPerNight: number;
  avgAmountPaxNight: number;
  currency: string;
  status: string;
  concept: string;
}

export interface ReportSummaryDTO {
  totalAmount: number;
  totalBookings: number;
  totalOfTotalRoomsPerNight: number;
  sumOfAvgAmounts: number;
  sumOfAvgStays: number;
  sumOfAvgAdvances: number;
  sumOfAvgAmountRoomPerNights: number;
  sumOfAvgAmountPaxNights: number;
  avgOfTotalAmount: number;
  avgOfTotalBookings: number;
  avgOfTotalOfTotalRoomsPerNight: number;
  avgOfAvgAmounts: number;
  avgOfAvgStays: number;
  avgOfAvgAdvances: number;
  avgOfAvgAmountRoomPerNights: number;
  avgOfAvgAmountPaxNights: number;
}

function numberRound(value: number): number {
  return Math.round(value * 100) / 100
}

export function dtoToEntity(dto: ReportDTO, type: ReportType, sumText: string, avgText: string): ReportEntity[] {
  if (!dto?.result?.length) {
    return [];
  }
  const entity = dto.result.map(((it, index) => ({
    id: index,
    avgAdvance: numberRound(it.avgAdvance),
    avgAmount: numberRound(it.avgAmount),
    avgOccupantNight: numberRound(it.avgAmountPaxNight),
    avgRoomsNight: numberRound(it.avgAmountRoomPerNight),
    avgStay: numberRound(it.avgStay),
    concept: it.concept,
    currency: it.currency,
    group: it.group,
    partner: it.partner,
    period: it.period,
    property: it.hotelTicker,
    status: it.status,
    totalAmount: numberRound(it.totalAmount),
    totalReservations: numberRound(it.bookings),
    totalRoomsNight: numberRound(it.totalRoomsPerNight),
  })));

  const sumEntity = emptySumEntity(dto, dto.result.length, entity[0].currency);
  const avgEntity = emptyAverageEntity(dto, dto.result.length + 1, entity[0].currency);
  switch (type) {
    case ReportType.DEFAULT:
      entity.push({ ...sumEntity, period: sumText });
      entity.push({ ...avgEntity, period: avgText });
      break;

    case ReportType.CONCEPT:
      entity.push({ ...sumEntity, concept: sumText });
      entity.push({ ...avgEntity, concept: avgText });
      break;

    case ReportType.STATUS:
      entity.push({ ...sumEntity, status: sumText });
      entity.push({ ...avgEntity, status: avgText });
      break;
  }
  return entity;
}

function emptySumEntity(dto: ReportDTO, id: number, currency: string): ReportEntity {
  return {
    id,
    avgAdvance: numberRound(dto.reportSummary.sumOfAvgAdvances),
    avgAmount: numberRound(dto.reportSummary.sumOfAvgAmounts),
    avgOccupantNight: numberRound(dto.reportSummary.sumOfAvgAmountPaxNights),
    avgRoomsNight: numberRound(dto.reportSummary.sumOfAvgAmountRoomPerNights),
    avgStay: numberRound(dto.reportSummary.sumOfAvgStays),
    concept: "",
    currency,
    group: "",
    partner: "",
    period: "",
    property: "",
    status: "",
    totalAmount: numberRound(dto.reportSummary.totalAmount),
    totalReservations: numberRound(dto.reportSummary.totalBookings),
    totalRoomsNight: numberRound(dto.reportSummary.totalOfTotalRoomsPerNight),
  }
}

function emptyAverageEntity(dto: ReportDTO, id: number, currency: string): ReportEntity {
  return {
    id,
    avgAdvance: numberRound(dto.reportSummary.avgOfAvgAdvances),
    avgAmount: numberRound(dto.reportSummary.avgOfAvgAmounts),
    avgOccupantNight: numberRound(dto.reportSummary.avgOfAvgAmountPaxNights),
    avgRoomsNight: numberRound(dto.reportSummary.avgOfAvgAmountRoomPerNights),
    avgStay: numberRound(dto.reportSummary.avgOfAvgStays),
    concept: "",
    currency,
    group: "",
    partner: "",
    period: "",
    property: "",
    status: "",
    totalAmount: numberRound(dto.reportSummary.avgOfTotalAmount),
    totalReservations: numberRound(dto.reportSummary.avgOfTotalBookings),
    totalRoomsNight: numberRound(dto.reportSummary.avgOfTotalOfTotalRoomsPerNight),
  }
}
